export default function analyticsURL() {
  return window.TC.Config.analytics_url;
}
